import { fmt } from '@/lib/utils';
import ProductoConfig from '../configs/ProductoConfig';

export default function StepConfig({ quote, setQuote }) {
  const updateProducto = (id, changes) => {
    setQuote((q) => ({
      ...q,
      productos: q.productos.map((p) =>
        p.id === id ? { ...p, ...changes, configurado: true } : p
      ),
    }));
  };

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Configura cada producto</h2>
      <p className="text-sm text-neutral-500 mb-6">
        Define las variables específicas. El precio se calcula automáticamente.
      </p>
      <div className="space-y-4">
        {quote.productos.map((p) => (
          <ProductoConfig
            key={p.id}
            producto={p}
            onUpdate={(c) => updateProducto(p.id, c)}
          />
        ))}
      </div>
      <div className="mt-5 p-5 bg-brand-gold/5 border border-brand-gold/30 rounded-xl flex items-center justify-between">
        <div>
          <div className="text-xs text-neutral-400 uppercase tracking-wider">
            Subtotal productos
          </div>
          <div className="text-2xl font-bold text-white">
            {fmt(quote.productos.reduce((s, p) => s + (p.precioFinal || 0), 0))}
          </div>
        </div>
        <div className="text-xs text-neutral-500">Antes de descuentos e IVA</div>
      </div>
    </div>
  );
}
